module.exports = __webpack_public_path__ + "img/currency.f1a36d08.svg";